import { Check, Minus } from "@untitled-ui/icons-react";
import { forwardRef, InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  indeterminate?: boolean;
}

export const CheckboxV2 = forwardRef<HTMLInputElement, IInputProps>(
  ({ checked, indeterminate, ...props }, ref) => {
    if (checked) indeterminate = false;

    return (
      <label
        className={twMerge(
          "relative h-5 w-5 block rounded-md bg-white transition-all ease-out border",
          (checked || indeterminate) && !props.disabled
            ? "border-brand-v2-600"
            : "border-gray-v2-300",
          props.disabled ? "bg-gray-v2-50" : "",
          props.className
        )}
      >
        <input
          ref={ref}
          {...props}
          className={`absolute top-0 left-0 z-10 h-full w-full rounded-md appearance-none ${
            props.disabled ? "cursor-not-allowed" : "cursor-pointer"
          }
          focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-v2-400`}
          type="checkbox"
        />
        <span
          className={`relative h-full w-full transition-all ease-out rounded-sm flex justify-center items-center ${
            props.disabled ? "" : "bg-brand-v2-600"
          } ${checked || indeterminate ? "" : "scale-[40%] opacity-0 rotate-12"}`}
        >
          <Check
            className={`absolute h-[70%] w-[70%] transition-all ease-out ${props.disabled ? "text-gray-v2-300" : "text-white"} ${checked ? "" : "scale-0"}`}
          />
          <Minus
            className={`absolute h-[70%] w-[70%] transition-all ease-out ${props.disabled ? "text-gray-v2-300" : "text-white"} ${indeterminate ? "" : "scale-0"}`}
          />
        </span>
      </label>
    );
  }
);

CheckboxV2.displayName = "CheckboxV2";
